import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'
import { mayOpenAdminPage } from '../../shared/alumni'

import AdminSupportRequests from '../../components/views/admin/SupportRequests'
import SupporterSupportRequests from '../../components/views/supporter/SupportRequests'

/**
 * Eine Route, zwei Sichten.
 *
 * Admins erfassen den Bedarf und sehen die Rückmeldungen. Unterstützer:innen
 * sehen nur die Bedarfe, die zu ihrem Profil passen, und antworten darauf.
 * Welche das sind, entscheidet der Server — nicht diese Weiche.
 */
function SupportRequestsPage(props) {
	if (mayOpenAdminPage(props.role, 'supportRequests')) return <AdminSupportRequests />
	if (props.role === TRoles.SUPPORTER) return <SupporterSupportRequests />

	return <Redirect to={TRoutes.DASHBOARD} />
}

SupportRequestsPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(SupportRequestsPage)
